import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { Platform } from '@ionic/angular';
import { ApiService } from '../api.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { HttpClient } from '@angular/common/http';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import * as htmlToImage from 'html-to-image';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-create-service',
  templateUrl: './create-service.component.html',
  styleUrls: ['./create-service.component.scss'],
})
export class CreateServiceComponent {
  htmlContent;
  description;
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    showToolbar: true,
    height: '10rem',
    minHeight: '10rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };
  list: any = [
    { name: 'General', style: 'none', id: 0 },
    { name: 'Pricing', style: 'none', id: 1 },
    { name: 'Service Details', style: 'none', id: 2 },
    { name: 'Image', style: 'none', id: 3 },
  ];
  blob; check:boolean; src;blob1;
  activeInd: boolean = true;
  loader:boolean = false;
  change:boolean;
  markedPrice;
  price;
  stockOutQty;
  actDuration;
  categorysearchtypes:any= [];
  Eqsearchtypes:any=[];
  serviceId;
  pic;
  item:any;
  duration;
  id;
  promotions: any = []; promoId; promotionName = 'Select';
  category: any = [];
  Eqtype: any= [];
  name;
  Eqname;
  discountName;
  discountId;
  discountObj;
  itemsub;
  itemCateName;
  itemCateId;
  coupon;
  itemCategoryObj;
  EqId;
  Id;
  defcost;
  units:any=[];
  unitName;
  unitId;
  billForUnits:boolean;
  cateName;
  itemCategory;
  cateId;
  editBool:boolean;
  pacService:any=[];
  pacServiceReg:any=[];
  postalCd;
  region;
  orgDetailObj:any=[];
  serviceDetails:any=[];
  taxIncluded:boolean;
  billPostVisit:boolean;
  header;
  url;
  orgId;
  cateCode;
  thumbnail;
  thumbnail1;
  videoName;
  provicerServiceId;
  videoId;
  couponId;
  videoChange:boolean;
  imageName;
  updateImage:boolean=false;
  vencost;
  constructor( protected sanitizer: DomSanitizer,   private router: Router, private bottomSheet: MatBottomSheet,  public handler: HandlerService, private platform: Platform,
    public service: ApiService, private http:HttpClient) { }

    ionViewWillEnter(){
      this.loader=true;
      sessionStorage.setItem('vendorApp','true');
      this.EqId = localStorage.getItem('currentUserId')
      this.orgId = localStorage.getItem('organizationId')
      this.url = window.location.href;
      this.list[0].style="active"
      this.getOrg();
      this.getUnits();
      this.getDiscount();      
      if (this.url.includes('edit-service')) {
           this.header="Edit Service";
          this.id = window.location.href.split('/').pop();
          this.service.getItemById(this.id).subscribe((res: any) => {
          this.item = res;
          this.name = res.name; 
          this.billForUnits = res.billForUnits; 
          this.unitName = res.units;     
          this.activeInd = res.activeInd;      
          this.taxIncluded = res.taxIncluded;
          this.billPostVisit = res.billPostVisit;
          this.actDuration = res.durationInMinutes;
          this.pacService = res.subCost;
          this.defcost = res.dfltCost;
          this.vencost = res.vendorCost;
          // this.units = res.units;
          this.couponId = res.discAdId;
          this.htmlContent = res.description;
          this.pic = res.img;
          this.videoId = res.docId;
          this.videoChange = false;
          if(res.imageId){
            this.getImageIcon(res.imageId)
          }
          if(res.docId){
            this.getVideIcon(res.docId)
          }
        setTimeout(() => {
          this.loader=false;
          this.getItemType();
          this.getCategory();
        }, 2000);
        
            },
          err => {
            this.handler.err(err);
            this.loader = false;
          })    
      }
      else {
        this.header="Create Service";
        // this.next3();
        setTimeout(() => {
          this.getItemType();
          this.getCategory();
          this.loader = false;
        }, 2000);
      }
  }

  getImageIcon(id){
    this.service.getAdImage(id).subscribe((res:any)=>{
      this.blob=res;
      this.pic= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
    },
    err=>{
      this.handler.err(err);
 
    })
  }

  getUnits(){
    this.service.getAllUnits().subscribe((res:any)=>{
      this.units=res;
    })
  }

  getVideIcon(id){
    this.check = true;
    this.service.getAdImage(id).subscribe((res:any)=>{
      this.blob=res;
      this.src= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      this.check = false;
    },
    err=>{
      this.handler.err(err);
 
    })
  }
    getCategory(){
      this.service.getOrgCategory().subscribe((res: any) => {
        this.category=res;
          if (this.category.length > 0) {
            setTimeout(() => {
              this.category.map(res1 => {
                if (res1.id == this.item.itemCategoryId) {
                  this.cateName = res1.name;
                  this.cateId = res1.id;
                  this.cateCode = res1.code;
                }
              })
            }, 1000);
          } 
      })
    }

    openBottomSheetCategoryType(){
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.category,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.cateName = res.name;
          this.cateId = res.id;
          this.cateCode = res.code;
          }
      });
    }

    openBottomSheetUnits(){
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.units,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if (res) {
          this.unitName = res.name;
          this.unitId = res.id;
          }
      });
    }

    getDiscount(){    
      this.service.getServiceCoupon(this.orgId).subscribe(res=>{
        this.discountObj = res;
  
        if (this.discountObj.length > 0) {
          setTimeout(() => {
            this.discountObj.map(res1 => {
              if (res1.id == this.couponId) {
                this.discountName = res1.name;
                this.discountId = res1.id;             
              }
            })
          }, 1000);
        } 
      })
    }

      
    openBottomSheetDiscount(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.discountObj,
      });
      dialogRef.afterDismissed().subscribe((res) => {
         this.discountName = res.name;
        this.discountId=res.id;
  
      });
    }

    handleFile(files) {
      if (files[0].size < 1048576) {
        this.blob1 = files[0];
        this.pic=this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.blob1));
        setTimeout(() => {
          this.captureScreen1();
          this.imageName = this.blob1.name;
        }, 1000);
        this.updateImage = true;
      }
      else {
        this.handler.res('Image Size Should Not Exceeds 1mb ');
      }
  
    }

    handleFile1(files) {
      this.videoChange = true;
      this.blob = files[0];
      this.src=this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.blob));
      setTimeout(() => {
        this.captureScreen();
        this.videoName = this.blob.name;
      }, 2000);
    }

    captureScreen(){
      var canvas = document.createElement('canvas');
      canvas.setAttribute('width', '600');
      canvas.setAttribute('height', '360');
      setTimeout(() => {
        var video: any = document.getElementById('vid');
        canvas.getContext('2d').drawImage(video, 0, 0, 600, 360);
        this.thumbnail= fetch(canvas.toDataURL())
        .then(res => res.blob())
        .then(res1 => (this.thumbnail = res1));
        
      })
    }

    captureScreen1(){
      let x = document.getElementById('slideData')
      htmlToImage.toJpeg(x, { quality: 0.20 }).then(dataUrl => {
        fetch(dataUrl).then(res=>res.blob()).then(res1=>this.thumbnail1=res1)
      },err => {
          console.error('oops, something went wrong!', err);
          this.loader=true;
      })
    }

    Save() {
      if (this.name != "" && this.name != null && this.cateId != "" && this.cateId != null  && this.actDuration != "" && this.actDuration != null && this.htmlContent != "" && this.htmlContent != null) {
        var costData;
           costData =this.pacService.every(res=>res.region && res.cost)       
        if(costData){
          this.editService();
        }else{
          this.handler.res("Please Enter Required Fields in Pricing Section");
        }
      }
      else {
        this.handler.res("Please Enter Required Fields");
      }
    }

    ServiceCreate(){
     if (this.name != "" && this.name != null && this.cateId != "" && this.cateId != null && this.actDuration != "" && this.actDuration != null&& this.htmlContent !="" && this.htmlContent != null) {
       if(this.cateCode=="CAR"){
        var costData;   
        costData =this.pacService.every(res=>res.region && res.cost)      
        if(costData){
          this.create();
        }else{
          this.handler.res("Please Enter Required Fields in Pricing Section");
        }
       }else{
        var costData;
        costData =this.pacService.every(res=> res.cost)
        if(costData){
          this.create();
        }else{
          this.handler.res("Please Enter Required Fields in Pricing Section");
        }
       }
            
      }
      else {
        this.handler.res("Please Enter Required Fields");
      }
    }

    create() {
      this.loader = true;
      let post; 
      var costItem=[]
      this.pacService.map(res=>{
      costItem.push({
      cost:res.cost,
      region:res.region,
      itemTypeId:res.itemTypeId
       }) 
      })
      
      if(this.name){
        this.name = this.name.toUpperCase();
      }
     post = {
      "name": this.name,
      "activeInd": true,
      "taxIncluded":this.taxIncluded,
      "billPostVisit":this.billPostVisit,
      "orgId":localStorage.getItem('organizationId'),
      "itemCategoryId":this.cateId,
      "description":this.htmlContent.replace(/[&]NBSP[;]/gi,""),
      "discAdId":this.discountId,
      "itemTypeId":this.itemCateId,
      "durationInMinutes":this.actDuration,
      "subCost":costItem,
      "packageInd":false,
      "dfltCost": this.defcost,
      "vendorCost":this.vencost, 
      "billForUnits":this.billForUnits,
      "units":this.unitName
      }  
       this.service.createItem(post).subscribe((res:any) => {
        this.uploadImage(res.id);
        this.handler.res("Service Created Successfully");
        if(this.src){
          this.provicerServiceId = res.id;
          this.upload();
        }else{
          this.loader = false;
          this.router.navigate(['/manageServices'])
        }
      },
        err => {
          this.loader = false;
          this.handler.err(err);
  
        })
    }
    uploadImage(id) {
      this.loader=true;
      this.service.uploadImageFile(this.blob1,this.imageName,id).subscribe((res:any) => {
        this.handler.res('Image Uploaded Succsessfully!!');
      },err=>{
        this.handler.err(err);
        this.loader = false;
      })
    }
   
    upload() {
      this.loader=true;
      this.service.uploadVideoFile(this.blob,this.videoName).subscribe((res:any) => {
        this.handler.res('Video Uploaded Succsessfully!!');
        this.uploadDocIcon(res.id)
      },err=>{
        this.handler.err(err);
        this.loader = false;
      })
    }
  

    uploadDocIcon(id){
      this.service.uploadDocIcon(id,this.thumbnail,this.provicerServiceId).subscribe(res=>{
        this.handler.res('Video Icon Updated Succsessfully!!');
        this.loader=false;
        this.router.navigate(['/manageServices'])
      },err=>{
        this.handler.err(err);
        this.loader = false;
      })
    }

    editService() {
      this.loader=true; 
      var costItem=[]
      this.pacService.map(res=>{
      costItem.push({
      cost:res.cost,
      region:res.region,
      itemTypeId:res.itemTypeId
       }) 
      })

        if (this.name) {
          this.name = this.name.toUpperCase();
        }
     
          this.item.name =  this.name;       
          this.item.activeInd =  this.activeInd;      
          this.item.taxIncluded = this.taxIncluded;
          this.item.billPostVisit = this.billPostVisit;
          this.item.durationInMinutes = this.actDuration;
          // this.item.img = this.pic;
          this.item.dfltCost = this.defcost;
          this.item.vendorCost = this.vencost;
          // this.item.units = this.units;
          this.item.subCost = costItem;     
          this.item.discAdId= this.discountId;
          this.item.billForUnits=this.billForUnits;
          this.item.units=this.unitName;
          this.item.description=this.htmlContent.replace(/[&]NBSP[;]/gi,""),
          this.item.itemTypeId = this.itemCateId;
          this.item.itemCategoryId = this.cateId;
          this.service.updateItem(this.id, this.item).subscribe((res:any) => {
          this.handler.res("Service Updated Successfully");
          if(this.updateImage){
            this.uploadImage(res.id);
          }
          if(!this.videoChange){
            this.loader = false;
            this.router.navigate(['/manageServices']); 
          }else{
            this.provicerServiceId = this.id;
            this.upload();
          }       
        },
          err => {
            this.loader = false;
            this.handler.err(err);
  
          })   
    }

    getAttributes(id) {
      this.service.getPromotions().subscribe(res => {
        this.promotions = res;
        if(id==2){
          if (this.promotions.length > 0 &&this.promoId) {
        let promo = this.promotions.find(dat => dat.id == this.promoId);
        this.promotionName = promo.name;
        this.promoId = promo.id;
        }
      }
      })


    setTimeout(() => {
      this.loader = false;
    }, 5000);
  }

  checkBox(data){
    data.style="active"
    var x = this.list.filter(res => res.id != data.id);
    x.map(res=>{
      Object.assign(res,{style:"none"})
    })  
  }

  getItemType(){
    this.service.getItemType().subscribe((res: any)=>{
      this.itemCategoryObj= res;
      this.next11();
    })
  }

  openBottomSheetItemType(dat){
    this.itemCategory = this.itemCategoryObj.filter(res=> res.itemCategory == this.cateId)
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.itemCategory,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
        dat.itemTypeName = res.name;
        dat.itemTypeId = res.id;
      }
    });
  }
  
  next1(){
    if (this.pacService.length > 0) {
      this.pacService.map(res => Object.assign(res, { icon: 'clear' }))
      this.pacService[this.pacService.length - 1].icon = 'add';
    }
    else {
       this.pacService.push({ region: "", icon: 'add',cost:""});
    }
  }

  add1(data, i) {
    if (data.icon === "clear") {        
      this.pacService.splice(i, 1);          
    }
    else {
      this.pacService[i].icon = "clear";
      this.pacService.push({ region: "", icon: 'add',cost:""});
    }
  }

  openBottomSheetService(data): void {
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.orgDetailObj,
    });
    dialogRef.afterDismissed().subscribe(res => {
      if(res){
        this.region=res.region;
        if(this.pacService.length==1){
          data.region =  this.region;
        }else{
          var x=this.pacService.filter(res=>res.region==this.region);
          if(x.length>0){
          var y =x[0].region;
          }
          if(y==undefined){
            data.region = this.region;
          }else{
            this.handler.error("This Region is already added.Please Choose Different Region");
          }
        }
      }
    });
  }

  openBottomSheetService1(data): void {
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.orgDetailObj,
    });
    dialogRef.afterDismissed().subscribe(res => {
      if(res){
        data.region =  res.region;
      }
    });
  }

  getOrg(){
    this.service.getOrgById(localStorage.getItem('organizationId')).subscribe((res: any) => {
   this.orgDetailObj=res.serviceRegions;
  })
}

// next(){
//   if (this.serviceDetails.length > 0) {
//     this.serviceDetails.map(res => Object.assign(res, { icon: 'clear' }))
//     this.serviceDetails[this.serviceDetails.length - 1].icon = 'add';
//   }
//   else {
//      this.serviceDetails.push({ serviceDetails: "", icon: 'add'});
//   }
// }

// add(data, i) {
//   if (data.icon === "clear") {        
//     this.serviceDetails.splice(i, 1);          
//   }
//   else {
//     this.serviceDetails[i].icon = "clear";
//     this.serviceDetails.push({ serviceDetails: "", icon: 'add'});
//   }
// }

ionViewWillLeave(){
  this.name="";
  this.actDuration="";
  this.pic="";
  this.src = "";
  this.src = undefined;
  this.pic = "";
  this.pic = undefined;
  this.pacService = []
  // this.serviceDetails = [];
  this.htmlContent= [];
  this.itemCateId = "";
  this.itemCateName="";
  this.cateId = "";
  this.cateName = "";
  this.item = "";
  this.list[1].style = 'none';
  this.list[2].style = 'none';
  this.list[3].style = 'none';
}

// remove3(i){
//   if(this.serviceDetails.length>1){
//     this.serviceDetails.splice(i, 1); 
//   }else{
//     this.handler.error("Can't Delete")
//   }  
// }

// next3(){
//   if (this.serviceDetails.length > 0) {
//     this.serviceDetails.map(res => Object.assign(res, { icon: 'clear' }))
//   }
//   else {
//      this.serviceDetails.push({ serviceDetails: "", icon: 'clear'});
//   }
// }

// add3() {
//   var len1 = this.serviceDetails.length;
//   if(this.serviceDetails[len1-1].serviceDetails !=""){
//     this.serviceDetails[len1-1].icon="clear";
//     this.serviceDetails.push({ serviceDetails: "", icon: 'clear'});
//   }else{
//     this.handler.error("Please Enter the Details")
//   }
// }

add11() {
  var len2 = this.pacService.length;
  if(this.pacService[len2-1].region !="" && this.pacService[len2-1].cost !=""){
    this.pacService[len2-1].icon="clear";
    this.pacService.push({ region: "", icon: 'clear',cost:"",itemTypeId:"",itemTypeName:""});
  }else{
    this.handler.error("Please Enter the Details")
  }
}

addReg(){
  var len = this.pacServiceReg.length;
  if(this.pacServiceReg[len-1].region !="" && this.pacService[len-1].cost !=""){
    this.pacServiceReg[len-1].icon="clear";
    this.pacServiceReg.push({ region: "", icon: 'clear',cost:""});
  }else{
    this.handler.error("Please Enter the Details")
  } 
}


remove1(i){
  if(this.pacService.length>1){
    this.pacService.splice(i, 1); 
  }else{
    this.handler.error("Can't Delete")
  }  
}

next11(){
  if (this.pacService.length > 0) {
    this.pacService.map(res => Object.assign(res, { icon: 'clear',itemTypeId:res.itemTypeId }));
    this.pacService.map(dat=>{
      this.itemCategoryObj.map(dat1=>{
        if(dat.itemTypeId == dat1.id){
          Object.assign(dat, { itemTypeName:dat1.name })
        }
      })
    })
  }
  else {
     this.pacService.push({ region: "", icon: 'clear',cost:"",itemTypeId:"",itemTypeName:""});
  }
}


}
